// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/storage/v1/experiment_service.proto (package ai.h2o.storage, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { FieldMask, proto3 } from "@bufbuild/protobuf";
import { FilterRequest, KeySelection, PagingRequest, PagingResponse, SortingRequest } from "./listing_pb.js";
import { Experiment } from "./experiment_pb.js";
import { Comment } from "./comment_pb.js";
import { Value } from "./value_pb.js";
import { Metric } from "./metric_pb.js";

/**
 * @generated from message ai.h2o.storage.GetExperimentRequest
 */
export const GetExperimentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.GetExperimentRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "response_metadata", kind: "message", T: KeySelection },
  ],
);

/**
 * @generated from message ai.h2o.storage.GetExperimentResponse
 */
export const GetExperimentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.GetExperimentResponse",
  () => [
    { no: 1, name: "experiment", kind: "message", T: Experiment },
  ],
);

/**
 * @generated from message ai.h2o.storage.CreateExperimentRequest
 */
export const CreateExperimentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CreateExperimentRequest",
  () => [
    { no: 1, name: "experiment", kind: "message", T: Experiment },
    { no: 3, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "response_metadata", kind: "message", T: KeySelection },
  ],
);

/**
 * @generated from message ai.h2o.storage.CreateExperimentResponse
 */
export const CreateExperimentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CreateExperimentResponse",
  () => [
    { no: 1, name: "experiment", kind: "message", T: Experiment },
  ],
);

/**
 * @generated from message ai.h2o.storage.UpdateExperimentRequest
 */
export const UpdateExperimentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.UpdateExperimentRequest",
  () => [
    { no: 1, name: "experiment", kind: "message", T: Experiment },
    { no: 2, name: "update_mask", kind: "message", T: FieldMask },
    { no: 3, name: "response_metadata", kind: "message", T: KeySelection },
  ],
);

/**
 * @generated from message ai.h2o.storage.UpdateExperimentResponse
 */
export const UpdateExperimentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.UpdateExperimentResponse",
  () => [
    { no: 1, name: "experiment", kind: "message", T: Experiment },
  ],
);

/**
 * @generated from message ai.h2o.storage.DeleteExperimentRequest
 */
export const DeleteExperimentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.DeleteExperimentRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListExperimentsRequest
 */
export const ListExperimentsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListExperimentsRequest",
  () => [
    { no: 2, name: "paging", kind: "message", T: PagingRequest },
    { no: 3, name: "filter", kind: "message", T: FilterRequest },
    { no: 4, name: "sorting", kind: "message", T: SortingRequest },
    { no: 5, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "response_metadata", kind: "message", T: KeySelection },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListExperimentsResponse
 */
export const ListExperimentsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListExperimentsResponse",
  () => [
    { no: 1, name: "paging", kind: "message", T: PagingResponse },
    { no: 2, name: "experiment", kind: "message", T: Experiment, repeated: true },
  ],
);

/**
 * @generated from message ai.h2o.storage.CountExperimentsRequest
 */
export const CountExperimentsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CountExperimentsRequest",
  () => [
    { no: 2, name: "filter", kind: "message", T: FilterRequest },
    { no: 3, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.CountExperimentsResponse
 */
export const CountExperimentsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CountExperimentsResponse",
  () => [
    { no: 1, name: "count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.LinkExperimentIntoProjectRequest
 */
export const LinkExperimentIntoProjectRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.LinkExperimentIntoProjectRequest",
  () => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.UnlinkExperimentFromProjectRequest
 */
export const UnlinkExperimentFromProjectRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.UnlinkExperimentFromProjectRequest",
  () => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.TagExperimentRequest
 */
export const TagExperimentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.TagExperimentRequest",
  () => [
    { no: 1, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tag_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.UntagExperimentRequest
 */
export const UntagExperimentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.UntagExperimentRequest",
  () => [
    { no: 1, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tag_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.CreateExperimentCommentRequest
 */
export const CreateExperimentCommentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CreateExperimentCommentRequest",
  () => [
    { no: 1, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "comment_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.CreateExperimentCommentResponse
 */
export const CreateExperimentCommentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CreateExperimentCommentResponse",
  () => [
    { no: 1, name: "comment", kind: "message", T: Comment },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListExperimentCommentsRequest
 */
export const ListExperimentCommentsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListExperimentCommentsRequest",
  () => [
    { no: 1, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "paging", kind: "message", T: PagingRequest },
    { no: 3, name: "filter", kind: "message", T: FilterRequest },
    { no: 4, name: "sorting", kind: "message", T: SortingRequest },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListExperimentCommentsResponse
 */
export const ListExperimentCommentsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListExperimentCommentsResponse",
  () => [
    { no: 1, name: "paging", kind: "message", T: PagingResponse },
    { no: 2, name: "comment", kind: "message", T: Comment, repeated: true },
  ],
);

/**
 * @generated from message ai.h2o.storage.CreateExperimentMetricRequest
 */
export const CreateExperimentMetricRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CreateExperimentMetricRequest",
  () => [
    { no: 1, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "value", kind: "message", T: Value },
  ],
);

/**
 * @generated from message ai.h2o.storage.CreateExperimentMetricResponse
 */
export const CreateExperimentMetricResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CreateExperimentMetricResponse",
  () => [
    { no: 1, name: "metric", kind: "message", T: Metric },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListExperimentMetricsRequest
 */
export const ListExperimentMetricsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListExperimentMetricsRequest",
  () => [
    { no: 1, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "paging", kind: "message", T: PagingRequest },
    { no: 3, name: "filter", kind: "message", T: FilterRequest },
    { no: 4, name: "sorting", kind: "message", T: SortingRequest },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListExperimentMetricsResponse
 */
export const ListExperimentMetricsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListExperimentMetricsResponse",
  () => [
    { no: 1, name: "paging", kind: "message", T: PagingResponse },
    { no: 2, name: "metric", kind: "message", T: Metric, repeated: true },
  ],
);

/**
 * @generated from message ai.h2o.storage.IsExperimentRegisteredRequest
 */
export const IsExperimentRegisteredRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.IsExperimentRegisteredRequest",
  () => [
    { no: 1, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.IsExperimentRegisteredResponse
 */
export const IsExperimentRegisteredResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.IsExperimentRegisteredResponse",
  () => [
    { no: 1, name: "is_registered", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.DeleteExperimentResponse
 */
export const DeleteExperimentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.DeleteExperimentResponse",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.BatchDeleteExperimentRequest
 */
export const BatchDeleteExperimentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.BatchDeleteExperimentRequest",
  () => [
    { no: 1, name: "experiment_request", kind: "message", T: DeleteExperimentRequest, repeated: true },
  ],
);

/**
 * @generated from message ai.h2o.storage.BatchDeleteExperimentResponse
 */
export const BatchDeleteExperimentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.BatchDeleteExperimentResponse",
  () => [
    { no: 1, name: "experiment_delete_response", kind: "message", T: DeleteExperimentResponse, repeated: true },
  ],
);

/**
 * @generated from message ai.h2o.storage.RecoverDeletedExperimentRequest
 */
export const RecoverDeletedExperimentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.RecoverDeletedExperimentRequest",
  () => [
    { no: 1, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.RecoverDeletedExperimentResponse
 */
export const RecoverDeletedExperimentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.RecoverDeletedExperimentResponse",
  () => [
    { no: 1, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.BatchRecoverDeletedExperimentRequest
 */
export const BatchRecoverDeletedExperimentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.BatchRecoverDeletedExperimentRequest",
  () => [
    { no: 1, name: "recover_experiment_requests", kind: "message", T: RecoverDeletedExperimentRequest, repeated: true },
  ],
);

/**
 * @generated from message ai.h2o.storage.BatchRecoverDeletedExperimentResponse
 */
export const BatchRecoverDeletedExperimentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.BatchRecoverDeletedExperimentResponse",
  () => [
    { no: 2, name: "recover_experiment_responses", kind: "message", T: RecoverDeletedExperimentResponse, repeated: true },
  ],
);

